import { useMutation, useQueryClient } from "@tanstack/vue-query";
import TemplateFolder from "@/services/template/template-folder";
import type { RegisterTemplateFolder } from "@/dtos/TemplateFolder.dto";

export function useCreateTemplateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: RegisterTemplateFolder) => {
      const response = await TemplateFolder.registerTemplateFolder(data);

      if (response.data.status) {
        return response.data.data;
      }

      throw new Error(response.data.msg || "Failed to create template folder");
    },
    onSuccess: () => {
      // Invalidate template folders query to refetch
      queryClient.invalidateQueries({ queryKey: ["templateFolders"] });
    },
  });
}
